import { Link } from 'react-router';
import { LazyLoadImage } from 'react-lazy-load-image-component';

import { Title } from '../../utils/title';
import Base from '../Base';
import styles from './Survey.module.scss';
import './common.css';

import social from '../../assets/custom/survey/social.png';

import survey_1 from '../../assets/custom/survey/survey_1.png';
import survey_2 from '../../assets/custom/survey/survey_2.png';
import survey_3 from '../../assets/custom/survey/survey_3.png';
import survey_4 from '../../assets/custom/survey/survey_4.png';
import survey_5 from '../../assets/custom/survey/survey_5.png';
import survey_6 from '../../assets/custom/survey/survey_6.png';
import survey_7 from '../../assets/custom/survey/survey_7.png';

import answer_3 from '../../assets/custom/survey/answer_3.png';
import answer_6 from '../../assets/custom/survey/answer_6.png';

const Survey = () => {

  const creationDate = 'April 3, 2024';
  const lastEditedDate = 'April 5, 2024';

  return (
    <Base>
      <div className={styles.root}>

        <Title value='Guiding Your Brand Through the Potential TikTok Ban' />

        {
          /*
           * BEGIN HTML
           */
        }
        <div className="blog-post container">
          <div className="row">
            <div id="main-content" className="col-12">
              <h1 className="blog-post__title">Guiding Your Brand Through the Potential TikTok Ban</h1>
              <p className="blog-post__meta">
                Created on {creationDate} | Last edited on {lastEditedDate}
              </p>
              <LazyLoadImage
                src={social}
                alt="Ring light and phone in front of an empty armchair"
                className="blog-post__image img-fluid"
              />
              <p className="blog-post__p">
                Chimeable, a leading platform for generating authentic product reviews and shareable
                video content, recently conducted a survey to understand social media usage trends and
                gather opinions on the potential ban of TikTok by the US government. With responses from
                132 participants, the survey offers insights into the behaviors and preferences of
                social media users.
              </p>
              <p className="blog-post__p">
                Among the general population, Facebook (76%), YouTube (63%), and Instagram (57%) emerged
                as the top three most popular platforms. TikTok secured the fourth position with a 38%
                adoption rate; a 5% increase compared to data from August 2023.
              </p>
              <br></br>
              <p className="blog-post__p">
                <i>
                  <b>
                    Question: Which social media platforms do you actively use? Please select all that
                    apply.{' '}
                  </b>
                  (100% Answered){' '}
                </i>
              </p>
              <LazyLoadImage
                src={survey_1}
                alt="Survey results in bar graph"
                className="blog-post__survey img-fluid"
              />
              <p className="blog-post__p">
                A significant aspect of the survey explored the alternative platforms individuals would
                turn to in the event of a TikTok ban. Instagram topped the list with 52% of respondents
                favoring it, followed closely by Facebook (44%), YouTube (30%), and Twitter (30%).
                Notably, approximately 20% expressed interest in exploring a brand new platform similar
                to TikTok, highlighting both a potential vacuum and an opportunity for the emergence of
                a new platform should TikTok be unavailable.
              </p>
              <br></br>
              <p className="blog-post__p">
                <i>
                  <b>
                    Question: If TikTok was banned by the US government tomorrow, which platform(s)
                    would you use instead to find similar content to TikTok?{' '}
                  </b>{' '}
                  (100% Answered)
                </i>
              </p>
              <LazyLoadImage
                src={survey_2}
                alt="Survey results in bar graph"
                className="blog-post__survey img-fluid"
              />
              <p className="blog-post__p">
                Furthermore, the survey delved into respondents' engagement with sponsored branded
                content, revealing that approximately 35% of the general population has posted such
                content. Among those who posted such content, 2 in 10 cited paid compensation from these
                platforms as their primary source of income, with half considering it at least a
                moderate contributor to their earnings. Furthermore, among those who shared sponsored
                content, TikTok users were more inclined to identify compensation from social platforms
                as their primary income source (32%), followed by Instagram users (25%).
              </p>
              <br></br>
              <p className="blog-post__p">
                <i>
                  <b>
                    Question: Have you ever posted sponsored branded content in exchange for a free
                    product or paid compensation?{' '}
                  </b>
                  (100% Answered, Answer order is same as the bars in the graph)
                </i>
              </p>
              <LazyLoadImage
                src={survey_3}
                alt="Survey results in bar graph"
                className="blog-post__survey img-fluid"
              />
              <LazyLoadImage src={answer_3} alt="Answers choices listed" className="blog-post__survey img-fluid" />
              <br></br>
              <p className="blog-post__p">
                <i>
                  <b>
                    Question: On a scale of 1 to 5, please rate the extent to which Paid Compensation
                    from social platforms contribute to your income.{' '}
                  </b>
                  (35% Answered, 65% Skipped)
                </i>
              </p>
              <LazyLoadImage
                src={survey_4}
                alt="Survey results in bar graph"
                className="blog-post__survey img-fluid"
              />

              <p className="blog-post__p">
                Opinions regarding the potential ban of TikTok were split among the US general
                population, with 47% advocating for its shutdown and 53% opposing the idea. Notably,
                only 38% of TikTok users supported the ban.
              </p>
              <br></br>
              <p className="blog-post__p">
                <i>
                  <b>Should the US government shut down TikTok? </b>(100% Answered)
                </i>
              </p>
              <LazyLoadImage
                src={survey_5}
                alt="Survey results in bar graph"
                className="blog-post__survey img-fluid"
              />
              <p className="blog-post__p">
                Moreover, when respondents were presented with various approaches to address the TikTok
                situation, 33% recommended imposing stricter regulations, 20% favored a complete ban,
                and 13% suggested compelling TikTok to sell to a US-based company.
              </p>
              <br></br>
              <p className="blog-post__p">
                <i>
                  <b>How do you think the US government should handle TikTok? </b>(100% Answered, Answer
                  order is same as the bars in the graph)
                </i>
              </p>
              <LazyLoadImage
                src={survey_6}
                alt="Survey results in bar graph"
                className="blog-post__survey img-fluid"
              />
              <LazyLoadImage src={answer_6} alt="Answers choices listed" className="blog-post__survey img-fluid" />

              <p className="blog-post__p">
                Moreover, a notable 68% of respondents agreed that there should be enhanced regulations
                enforced by the US government across social media platforms in general.
              </p>
              <br></br>
              <p className="blog-post__p">
                <i>
                  <b>
                    Do you think there should be more regulations enforced by the US government onto
                    social media platforms in general?{' '}
                  </b>
                  (100% Answered)
                </i>
              </p>
              <LazyLoadImage
                src={survey_7}
                alt="Survey results in bar graph"
                className="blog-post__survey img-fluid"
              />
              <p className="blog-post__p">
                Chimeable's survey sheds light on the dynamic landscape of social media usage and public
                sentiment surrounding TikTok, offering valuable insights for policymakers and industry
                stakeholders alike.
              </p>
              <p className="blog-post__p">
                For media inquiries or further information, please email contact@chimeable.com.
              </p>
              <br></br>
              <br></br>
              <div className="customBox text-light font-redhat-regular ">
                <p>
                  Do you need more reviews for your product to increase your sales and provide more
                  insight? Chimeable can help you.
                </p>
                <div className="buttonWrapper">
                  <Link
                    to="?dialog=contact"
                    className="blog-button btn rounded-5 text-dark fw-bold font-redhat-regular"
                    aria-label="book a demo">
                    Get More Reviews
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
        {
          /*
           * END HTML
           */
        }

      </div>
    </Base>
  );
};

export default Survey;